import * as r from "./NavigatorScreens";

const routes = r;
export default routes;
